import React from 'react';
import styled from '@emotion/styled';
import Heading from '~ComponentsImproved/Typography/Heading';

import { useCurrency, useI18n } from '~Hooks';
import { useCart } from '~Components/CartProvider';

const TextWrapper = styled.div<{ hasBorder?: boolean }>`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: ${({ hasBorder }) => (hasBorder ? '8px 16px' : '0 16px')};
  margin: 8px 0;
  border-top: ${({ hasBorder }) => (hasBorder ? '1px solid var(--colorBlueGray1200)' : 'none')};
`;

const CartTotals = () => {
  const cart = useCart();
  const { i18n } = useI18n();
  const currency = useCurrency();

  const serviceChargeItem = cart.items.find((item) =>
    item.title.toLowerCase().includes('service charge'),
  );

  return (
    <>
      {serviceChargeItem ? (
        <TextWrapper>
          <Heading level={5} color="white">
            {serviceChargeItem.title}
          </Heading>
          <Heading level={5} color="white">
            {serviceChargeItem.price ? currency.format(serviceChargeItem.price) : '-'}
          </Heading>
        </TextWrapper>
      ) : null}
      <TextWrapper>
        <Heading level={5} color="white">
          {i18n('POS.Discount')}
        </Heading>
        <Heading level={5} color="white">
          {currency.format(cart.discount)}
        </Heading>
      </TextWrapper>
      <TextWrapper hasBorder>
        <Heading level={3} color="white">
          {i18n('POS.Total')}
        </Heading>
        <Heading level={3} color="white">
          {currency.format(cart.total - cart.discount)}
        </Heading>
      </TextWrapper>
    </>
  );
};

export default React.memo(CartTotals);
